<script lang="ts">
	import { twMerge } from 'tailwind-merge';

	let { children, class: classList = '' } = $props();
</script>

<p class={twMerge('text-foreground/60 lg:text-xl', classList)}>{@render children()}</p>
